function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  let user = getCookie("username");
  if (user != "") {
    alert("Welcome again " + user);
  } else {
    user = prompt("Please enter your name:", "");
    if (user != "" && user != null) {
      setCookie("username", user, 365);
    }
  }
}

/* ========================================== 
scrollTop() >= Should be equal the the height of the header
========================================== */

$(window).scroll(function(){
  var headerHeight = $(".header").outerHeight();
  if ($(window).scrollTop() >= headerHeight) {

    $('.header,#shopify-section-pxs-announcement-bar').addClass('fixed');
    $('.header').css({
      'top' : $("#shopify-section-pxs-announcement-bar").height() + 'px'
    })
  } else {
    $('.header,#shopify-section-pxs-announcement-bar').removeClass('fixed');
    $('.header').css({
      'top' : '0px'
    })
  }
});
// PDP Mobile image slider 
custom_theme.pdpImageSlider = function(imgEle) {
  var $that = imgEle;
  var imgSrc, targetIndex;
  $that.addClass("active").siblings('.product-slideshow-pagination-item').removeClass("active");
  imgSrc= $that.attr("data-default-res");
  targetIndex = $that.attr("data-image-id");
  $(".product-main-image img").attr('src',imgSrc);
};
custom_theme.updateProductImage = function(e, index) {
  var $target, newSrc, targetIndex;
  if (e) {
    e.preventDefault();
  }
  $(".product-thumb-image").find(".product-slideshow-pagination-item.active").removeClass("active");
  $target = e ? $(e.currentTarget) : $(".images-part").find(".product-thumb-image .product-slideshow-pagination-item").eq(index);
  newSrc = $target.data("default-res");
  targetIndex = $target.attr("data-image-id");
  $target.addClass("active");
  $(".product-thumb-image").find(".product-slideshow-pagination-item .product-img").attr({
    src: newSrc,
    'data-image-id' : targetIndex
  });
};

custom_theme.pdpImageSliderUsingNavArrow = function(targetElement){
  var index, target, total, newSrc,
      that = targetElement;
  total = that.closest(".product-main-image").find(".product-slideshow-pagination-item").size() - 1;
  index = that.closest(".product-main-image").find(".product-slideshow-pagination-item.active").index();
  if (that.hasClass("product-slideshow-next")) {
    if (index === total) {
      target = 0;
    } else {
      target = that.closest(".product-main-image").find(".product-slideshow-pagination-item.active").next().index();
    }
  } else {
    if (index === 0) {
      target = total;
    } else {
      target = that.closest(".product-main-image").find(".product-slideshow-pagination-item.active").prev().index();
    }
  }
  return custom_theme.updateProductImage(false, target);
}
custom_theme.videoPlay = function(that){
  var videoLink = that.attr("data-alt"),
      videoId = that.attr("data-video-id");
  var videoHtml = `<video controls loop">
                    <source src="${videoLink}" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>`;
  $('.product-image-container .product-big-image').find("img").attr("data-image-id",videoId).hide();
  $('.product-image-container .product-big-image').find('video').remove();
  $('.product-image-container .product-big-image').append(videoHtml);
  $(".product-image-container").addClass('video-wrap');
  $(".product-image-container").find(".product-slideshow-navigation").hide();
}
// $(document).on("click", ".product-main-image .product-slideshow-navigation.product-slideshow-next", function(){
//   var thatNextImg = $(".product-slideshow-pagination-item.active").next();
//   var tergetImg = $(".product-slideshow-pagination-item.active").removeClass("active");
//   $(".product-main-image img").attr("src",thatNextImg.attr("data-default-res"));
//   thatNextImg.addClass("active");
//   $(".product-slideshow-navigation.product-slideshow-previous").removeClass("disabled");
//   if(thatNextImg.hasClass("last-image")){
//     $(".product-slideshow-navigation.product-slideshow-next").addClass("disabled");
//   } else {
//     $(".product-slideshow-navigation.product-slideshow-next").removeClass("disabled");
//   }
// })
// $(document).on("click", ".product-main-image .product-slideshow-navigation.product-slideshow-previous", function(){
//   var thatNextImg = $(".product-slideshow-pagination-item.active").prev();
//   $(".product-slideshow-navigation.product-slideshow-next").removeClass("disabled");
//   var tergetImg = $(".product-slideshow-pagination-item.active").removeClass("active");
//   $(".product-main-image img").attr("src",thatNextImg.attr("data-default-res"));
//   thatNextImg.addClass("active");
//   if(thatNextImg.hasClass("first-image")){
//     $(".product-slideshow-navigation.product-slideshow-previous").addClass("disabled");
//   } else {
//     $(".product-slideshow-navigation.product-slideshow-previous").removeClass("disabled");
//   }
// })
// custom_theme.miniCartInit
custom_theme.miniCartInit = function() {
  var url = "/cart?view=side-cart";
  $.ajax({
    url: url,
    success: function(cartpage) {
      if ($(".side-cart-drawer").length > 0) {
        $(".side-cart-drawer").html(cartpage);
        $.getJSON('/cart.js', function(cart){
          $(".cart .count").html(cart.item_count);
          $('.cart-icon .count').html(cart.item_count);
        });
        $(".cart-drawer").click();
      } 
    }
  });
  
  $.getJSON('/cart.js', function(cart){
    console.log(cart);
    console.log('carttttttttt');
    var notetext = '';
    $(cart.items).each(function(i,e){
      if(e.properties['Breadth Size'] != undefined && e.properties['Height Size'] != undefined && e.properties['Length Size'] != undefined){
        notetext += `[SKU = ${e.sku} || Length - ${e.properties['Length Size']} || Breadth - ${e.properties['Breadth Size']} || Height - ${e.properties['Height Size']} ]`;
      }
    });
    fetch(`/cart/update.js`, {
      body: JSON.stringify({ note: notetext }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    });
    // $.ajax({      
    //   method: "POST",
    //   url: '/cart/update.js',    
    //   dataType :'JSON',
    //   data: { note: notetext },      
    //   success: function(){
    //     console.log('jijij');
        
    //   }
    //   // Allows to make sure the request is fired even when submitting the form
    // });
   });
    
};
// custom_theme.miniCartUpdate
custom_theme.miniCartUpdate = function(form){
  var params = {
    type: 'POST',
    url: '/cart',
    data: form.serialize(),
    dataType: 'json',
    success: function(line_item) {
      var cart_count = line_item.item_count;
      $(".cart .count").html(cart_count);
      custom_theme.miniCartInit();
    },
    error: function(XMLHttpRequest, textStatus) {
      var error = JSON.parse((XMLHttpRequest.responseText)).description;
      error = "<h6>" + error + "</h6>";
      $("#fancy-msg").html("").append(error);
      $.fancybox.open("#fancy-msg");
    }
  };
  $(".side-cart-drawer .no_data").fadeOut();
  jQuery.ajax(params);
}
/* ========================================== 
Click event added
========================================== */
custom_theme.clickEvent = function(){
  // minicart open 
  if($(".cart-drawer").length>0){
    $(document).on("click",".product-form__cart-submit", function(e){
      e.preventDefault();      
      var variantId = $(".custom-variants-dropdown").val(),
          varQty = $("#Quantity").val();
      var data = '';
      var __this = $(this);
      if($(this).closest('.pdp-form-wrapper').find('.combine-product-tabs--right').hasClass('active')){ 
        $('.form-info').hide();
        var $parent = $(this).closest('.pdp-form-wrapper').find('.swatch-size-wrapper');
        var length = $parent.find('input[name="properties[Length]"]').val();
        var breadth = $parent.find('input[name="properties[Breadth]"]').val();
        console.log(length);
        console.log(breadth);
        if(length == '' || breadth == ''){
          $('.form-info').removeClass('success').addClass('error').html('All fields are mandatory').fadeIn().delay(3000).fadeOut('fast');
        } else if (parseInt(length) < 15 || parseInt(breadth) < 15 || parseInt(length) > 84 || parseInt(breadth) > 84){
          alert('Please ensure that you have added your dimensions in inches and not in feet/cms');
          $('.form-info').removeClass('success').addClass('error').html('Please ensure that you have added your dimensions in inches and not in feet/cms').fadeIn().delay(3000).fadeOut('fast');             
        } else if (length.indexOf('.') > -1 || breadth.indexOf('.') > -1){
          alert('Please ensure that you have added your dimensions without any decimals');
          $('.form-info').removeClass('success').addClass('error').html('Please ensure that you have added your dimensions without any decimals.').fadeIn().delay(3000).fadeOut('fast');      
        } else {
          if($(".template-name-instabed").length==0){
            var button = $(this);
            $(this).find("span").text("Adding...");
          }
          length = parseFloat(length);
          breadth = parseFloat(breadth);
          height = null;
          $('.swatch-size-wrapper .swatch-opt').each(function(index, elem){
            if(index > 0){
              height = parseInt($(this).find('select.active').val());
            }
          });
          try{
            if(custom_theme.current_v && custom_theme.product.productVariants){
              var size_index = custom_theme.current_v.sizeIndex;
              var size_arr = custom_theme.product.productVariants;
              var filteredSizeArr = size_arr.filter(function(v){
                if(v.available){
                  var sizeOpt = v[size_index].toLowerCase();
                  var sizeOptArr = sizeOpt
                  .replace(/inch/g,'')
                  .trim()
                  .split('x');
                  var v_len = parseFloat(sizeOptArr[0].trim());
                  var v_width = parseFloat(sizeOptArr[1].trim());
                  var v_height = parseFloat(sizeOptArr[2].trim());                  
                  return v_len == length && v_width == breadth && height == v_height ;
                } else {
                  return 0;
                }
              });
              if(filteredSizeArr.length == 0){
               filteredSizeArr = size_arr.filter(function(v){
                  if(v.available){
                    var sizeOpt = v[size_index].toLowerCase();
                    var sizeOptArr = sizeOpt
                    .replace(/inch/g,'')
                    .trim()
                    .split('x');
                    var v_len = parseFloat(sizeOptArr[0].trim());
                    var v_width = parseFloat(sizeOptArr[1].trim());
                    var v_height = parseFloat(sizeOptArr[2].trim());
                    if (height == '6' || height == '8' || height== '10' || height== '7' || height== '9' ) {
                      return v_len >= length && v_width >= breadth && v_height >= height  ;                  
                    } else {
                      return v_len >= length && v_width >= breadth && height >= v_height ;
                    }
                  } else {
                    return 0;
                  }
                }); 
              }              
              if(filteredSizeArr.length){
                filteredSizeArr = filteredSizeArr;
                var v_id = filteredSizeArr[0].id;
                var found_v = $('form[action="/cart/add"] select[name="id"] option[value="'+v_id+'"]').attr('value');
                var foundMatch = false;                                                
                if(!found_v){
                  filteredSizeArr.map(function(v){
                    if(foundMatch){
                      return false;
                    }
                    found_v = $('form[action="/cart/add"] select[name="id"] option[value="'+(v.id)+'"]').attr('value');
                    if(found_v){
                      foundMatch = true;
                    }
                  });
                }
                if(found_v){
                  $('.form-info').removeClass('error').addClass('success').html('Variant Found!').fadeIn();
                  setTimeout(function(){
                    $('.form-info').hide();
                  },3000);
                  $('select.custom-variants-dropdown').val(found_v).trigger('change');
                  custom_theme.changePDPData();
                  var selectedVarId = $(".custom-variants-dropdown").val(),
                      selectedVarQty = $("#Quantity").val(),
                      data = {
                        id: selectedVarId,
                        quantity: selectedVarQty,
                        properties: {
                          'Length Size': $("#lengthInput").val(),
                          'Breadth Size': $("#breadthInput").val(),
                          'Height Size' :$(".single-option-selector-height").val()
                        }
                      };
                  $.ajax({
                    url: "/cart/add.js",
                    type: "post",
                    dataType :'JSON',
                    data: data,
                    success: function(){
                      custom_theme.miniCartInit();
                    }
                  })
                }
              } else {
                $('.form-info').removeClass('success').addClass('error').html('Sorry!, No variant found.').fadeIn();
                if($(".template-name-instabed").length==0){
                  if(__this.hasClass('has_preroder')){
                    __this.find("span").text("Pre order");
                  }else{
                    __this.find("span").text("Add to cart");
                  }            
                }
              }
            }
          } catch(err){
            console.error('Error', err);
            if($(".template-name-instabed").length==0){
              if(__this.hasClass('has_preroder')){
                __this.find("span").text("Pre order");
              }else{
                __this.find("span").text("Add to cart");
              }            
            }
          }
        }
      //   if($(this).hasClass('has_preroder')){          
      //     data = {
      //       quantity: varQty,
      //       id: variantId,
      //       properties: {
      //         'Type': 'Pre-order',
      //         'Length Size': $("#lengthInput").val(),
      //         'Breadth Size': $("#breadthInput").val(),
      //         'Height Size' :$(".single-option-selector-height").val()
      //       }
      //     }
      //   }else{
      //      data = {
      //       quantity: varQty,
      //       id: variantId,
      //       properties: {
      //         'Length Size': $("#lengthInput").val(),
      //         'Breadth Size': $("#breadthInput").val(),
      //         'Height Size' :$(".single-option-selector-height").val()
      //       }
      //     } 
      //   } 
      } else {        
        if($(this).hasClass('has_preroder')){
          data = {
              quantity: varQty,
              id: variantId,
              properties: {
                'Type': 'Pre-order'
              }
            };
        }else{
           data = {
              quantity: varQty,
              id: variantId
            }; 
        }  
        $.ajax({
          url: "/cart/add.js",
          type: "post",
          dataType :'JSON',
          data: data,
          success: function(cart){
            console.log(cart);
            custom_theme.miniCartInit();
            if($(".template-name-instabed").length==0){
              if(__this.hasClass('has_preroder')){
                __this.find("span").text("Pre order");
              }else{
                __this.find("span").text("Add to cart");
              }            
            }
          },
          error: function(){
            $('.buy-now').removeAttr("disabled");
            if($(".template-name-instabed").length==0){
              $('.buy-now').html('BUY NOW');
            }
          }
        })
      }
          
    })
  }

  // custom checkout button 
  $(document).on("click",".customBuyButton",function(){
    var variantId = $(".custom-variants-dropdown").val(),
        varQty = $("#Quantity").val(),
        closest = $(this).closest('.pdp-form-wrapper');
    var data = '';   
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function() { 
        if(closest.find('.combine-product-tabs--right').hasClass('active')){ 
          $('.form-info').hide();
          var $parent = closest.find('.swatch-size-wrapper');
          var length = $parent.find('input[name="properties[Length]"]').val();
          var breadth = $parent.find('input[name="properties[Breadth]"]').val();      
          if(length == '' || breadth == ''){
            $('.form-info').removeClass('success').addClass('error').html('All fields are mandatory').fadeIn().delay(3000).fadeOut('fast');
          } else if (parseInt(length) < 15 || parseInt(breadth) < 15 || parseInt(length) > 84 || parseInt(breadth) > 84){
            alert('Please ensure that you have added your dimensions in inches and not in feet/cms');
            $('.form-info').removeClass('success').addClass('error').html('Please ensure that you have added your dimensions in inches and not in feet/cms').fadeIn().delay(3000).fadeOut('fast');             
          } else if (length.indexOf('.') > -1 || breadth.indexOf('.') > -1){
            alert('Please ensure that you have added your dimensions without any decimals');
            $('.form-info').removeClass('success').addClass('error').html('Please ensure that you have added your dimensions without any decimals.').fadeIn().delay(3000).fadeOut('fast');      
          } else {
            var __this = $(this);
            if($(".template-name-instabed").length==0){
              var button = $(this);
              $(this).find("span").text("Adding...");
            }
            length = parseFloat(length);
            breadth = parseFloat(breadth);
            height = null;
            $('.swatch-size-wrapper .swatch-opt').each(function(index, elem){
              if(index > 0){
                height = parseInt($(this).find('select.active').val());
              }
            });
            try{
              if(custom_theme.current_v && custom_theme.product.productVariants){
                var size_index = custom_theme.current_v.sizeIndex;
                var size_arr = custom_theme.product.productVariants;
                var filteredSizeArr = size_arr.filter(function(v){
                  if(v.available){
                    var sizeOpt = v[size_index].toLowerCase();
                    var sizeOptArr = sizeOpt
                    .replace(/inch/g,'')
                    .trim()
                    .split('x');
                    var v_len = parseFloat(sizeOptArr[0].trim());
                    var v_width = parseFloat(sizeOptArr[1].trim());
                    var v_height = parseFloat(sizeOptArr[2].trim());                    
                    return v_len == length && v_width == breadth && height == v_height ;
                  } else {
                    return 0;
                  }
                });
                if(filteredSizeArr.length == 0){
                  filteredSizeArr = size_arr.filter(function(v){
                    if(v.available){
                      var sizeOpt = v[size_index].toLowerCase();
                      var sizeOptArr = sizeOpt
                      .replace(/inch/g,'')
                      .trim()
                      .split('x');
                      var v_len = parseFloat(sizeOptArr[0].trim());
                      var v_width = parseFloat(sizeOptArr[1].trim());
                      var v_height = parseFloat(sizeOptArr[2].trim());
                      if (height == '6' || height == '8' || height== '10' || height== '7' || height== '9' ) {
                        return v_len >= length && v_width >= breadth && v_height >= height  ;                    
                      } else {
                        return v_len >= length && v_width >= breadth && height >= v_height ;
                      }
                    } else {
                      return 0;
                    }
                  });
                }
                if(filteredSizeArr.length){
                  filteredSizeArr = filteredSizeArr;
                  var v_id = filteredSizeArr[0].id;                  
                  
                  var found_v = $('form[action="/cart/add"] select[name="id"] option[value="'+v_id+'"]').attr('value');
                  var foundMatch = false;
                  if(!found_v){
                    filteredSizeArr.map(function(v){
                      if(foundMatch){
                        return false;
                      }
                      found_v = $('form[action="/cart/add"] select[name="id"] option[value="'+(v.id)+'"]').attr('value');
                      if(found_v){
                        foundMatch = true;
                      }
                    });
                  }
                  if(found_v){
                    $('.form-info').removeClass('error').addClass('success').html('Variant Found!').fadeIn();
                    setTimeout(function(){
                      $('.form-info').hide();
                    },3000);
                    $('select.custom-variants-dropdown').val(found_v).trigger('change');
                    custom_theme.changePDPData();
                    var selectedVarId = $(".custom-variants-dropdown").val(),
                        selectedVarQty = $("#Quantity").val(),
                        data = {
                          id: selectedVarId,
                          quantity: selectedVarQty,
                          properties: {
                            'Length Size': $("#lengthInput").val(),
                            'Breadth Size': $("#breadthInput").val(),
                            'Height Size' :$(".single-option-selector-height").val()
                          }
                        };
                    $.ajax({
                      url: "/cart/add.js",
                      type: "post",
                      dataType :'JSON',
                      data: data,
                      success: function(){
                        console.log(filteredSizeArr[0].sku,$("#lengthInput").val(),$("#breadthInput").val());
                        var notetext = `[SKU = ${filteredSizeArr[0].sku} || Length - ${$("#lengthInput").val()} || Breadth - ${$("#breadthInput").val()} || Height - ${$(".single-option-selector-height").val()} ]`;
                        $.ajax({
                          url: "/cart/update.js",
                          type: "post",
                          dataType :'JSON',
                          data: { note: notetext },
                          success: function(){
                            window.location.href =  '/checkout';   
                          }
                        })                        
                      }
                    })
                  }
                } else {
                  $('.form-info').removeClass('success').addClass('error').html('Sorry!, No variant found.').fadeIn();
                  if($(".template-name-instabed").length==0){
                    if(__this.hasClass('has_preroder')){
                      button.find("span").text("Pre order");
                    }else{
                      button.find("span").text("Add to cart");
                    }            
                  }
                }
              }
            } catch(err){
              console.error('Error', err);
              if($(".template-name-instabed").length==0){
                if(__this.hasClass('has_preroder')){
                  button.find("span").text("Pre order");
                }else{
                  button.find("span").text("Add to cart");
                }            
              }
            }
          }
        //   if($(this).hasClass('has_preroder')){          
        //     data = {
        //       quantity: varQty,
        //       id: variantId,
        //       properties: {
        //         'Type': 'Pre-order',
        //         'Length Size': $("#lengthInput").val(),
        //         'Breadth Size': $("#breadthInput").val(),
        //         'Height Size' :$(".single-option-selector-height").val()
        //       }
        //     }
        //   }else{
        //      data = {
        //       quantity: varQty,
        //       id: variantId,
        //       properties: {
        //         'Length Size': $("#lengthInput").val(),
        //         'Breadth Size': $("#breadthInput").val(),
        //         'Height Size' :$(".single-option-selector-height").val()
        //       }
        //     } 
        //   } 
        } else { 
          if($(this).hasClass('has_preroder')){
            data = {
                quantity: varQty,
                id: variantId,
                properties: {
                  'Type': 'Pre-order'
                }
              };
          }else{
             data = {
                quantity: varQty,
                id: variantId
              }; 
          }  
          $.ajax({
            url: "/cart/add.js",
            type: "post",
            dataType :'JSON',
            data: data,
            success: function(cart){
              $.ajax({
                url: "/cart/update.js",
                type: "post",
                dataType :'JSON',
                data: { note: '' },
                success: function(){
                  window.location.href =  '/checkout';   
                }
              })              
            },
            error: function(){
              $('.buy-now').removeAttr("disabled");
              if($(".template-name-instabed").length==0){
                $('.buy-now').html('BUY NOW');
              }
            }
          })
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        /* error code */
      }
    });    
  })

  //item remove from sidecart drawer
  $(document).on("click", ".side-cart-drawer .cart__remove", function() {
    var input = $(this).closest(".cart__row").find(".cart__qty-input");
    input.val(0);
    var form = $(".side-cart-drawer form");
    custom_theme.miniCartUpdate(form);
  });
  // qty plus and update cart sidecart drawer
  $(document).on("click", ".side-cart-drawer .qty-btn.plus", function() {
    var target = $(this).siblings("input");
    var value = parseInt(target.val()) + 1;
    $(this).closest(".cart__row").find(".cart__qty-input").val(value);
    var form = $(".side-cart-drawer form");
    custom_theme.miniCartUpdate(form);
  });
  // qty minus and update cart sidecart drawer
  $(document).on("click", ".side-cart-drawer .qty-btn.minus", function() {
    var target = $(this).siblings("input");
    var value = parseInt(target.val());
    var value = value - 1;
    $(this).closest(".cart__row").find(".cart__qty-input").val(value);
    var form = $(".side-cart-drawer form");
    custom_theme.miniCartUpdate(form);
  });
  //  close all functionality on bg-transparent 
  $(document).on("click", ".bg-transparent", function(){
    $(this).removeClass("active");
    if($(".side-cart-drawer").hasClass("active")){
      $(".side-cart-drawer").removeClass("active");
    }
    if($("#mobile-sidebar-drawer").hasClass("open")){
      $("#mobile-sidebar-drawer").removeClass("open");
    }
    $('body').css('overflow','visible')
  })
  if ($(".template-index").length > 0) {
    if($(window).width() < 767){
      // tabbing arrow on click event
      $(document).on("click", ".tab-heading .next-arrow", function(){
        var nextEleTarget = $(this).parent().next().attr("data-target");
        $(this).parent().removeClass("active");
        $(this).parent().next().addClass("active");
        $(this).closest(`.tab-box`).find(`.tab-content li`).removeClass("active");
        $(this).closest(`.tab-box`).find(`.tab-content [data-id="${nextEleTarget}"]`).addClass("active");
      });
      // tabbing arrow on click event
      $(document).on("click", ".tab-heading .prev-arrow", function(){
        var prevEleTarget = $(this).parent().prev().attr("data-target");
        $(this).parent().removeClass("active");
        $(this).parent().prev().addClass("active");
        $(this).closest(`.tab-box`).find(`.tab-content li`).removeClass("active");
        $(this).closest(`.tab-box`).find(`.tab-content li[data-id="${prevEleTarget}"]`).addClass("active");
      })
    } else {
      $(document).on('click','.tab-heading > li', function(e){
        var target = $(this).data('target');
        var $parent = $(this).closest('.tab-box');
        $(this).addClass('active').siblings('li').removeClass('active');
        $parent.find('.tab-content > [data-id="'+ target +'"]').addClass('active').siblings('li').removeClass('active');
      });
    }
  } else {
     $(document).on('click','.tab-heading > li', function(e){
      var target = $(this).data('target');
      var $parent = $(this).closest('.tab-box');
      $(this).addClass('active').siblings('li').removeClass('active');
      $parent.find('.tab-content > [data-id="'+ target +'"]').addClass('active').siblings('li').removeClass('active');
      if($parent.find('.image-parent-wrap[data-id="'+ target +'"]').length > 0){
       $parent.find('.image-parent-wrap[data-id="'+ target +'"]').addClass('active').siblings('.image-parent-wrap').removeClass('active'); 
      }      
    });
  }
  // review scroll to top 
  $(document).on("click", ".loox-review-start-wrap", function(){
    $('html, body').animate({
      scrollTop: $('#looxReviews').offset().top - $(".header").height() - 300
    }, 1000);
  })
  // side cart open 
  $(document).on("click", ".cart-icon .cart-drawer", function(){
    $(".side-cart-drawer").addClass("active");
    $(".bg-transparent").addClass("active")
    $("body").css("overflow","hidden")
  });
  //  side cart close 
  $(document).on("click", ".side-cart-drawer .close-icon", function(){
    $(".side-cart-drawer").removeClass("active");
    $(".bg-transparent").removeClass("active")
    $("body").css("overflow","visible");
  });
  // PDP Page mobile device
  $(document).on('click', '.product-slideshow-pagination-item', function(){
    if($(this).hasClass("video-button")){
      custom_theme.videoPlay($(this));
    } else {
      // $(".product-image-container").find(".product-slideshow-navigation").show();
      custom_theme.pdpImageSlider($(this));
    }
  });
  if ($(".template-aloe-vera-mattress-protector .measurement-selector-wrapper").length > 0 || $(".template-flo-bedsheet .measurement-selector-wrapper").length > 0 || $(".template-baby-mattress").length > 0) {
    $(document).on("change",".single-option-selector", function(){
      if ($(".template-baby-mattress").length > 0) {
        // var firstValue = $(this).closest(".product-form").find(".custom-variants-box li.active").attr("data-tab-value");
        // if($(this).attr("data-index") == 'option2'){
        //   var selectedDropDownVal = $(this).val(); 
        //   var thirdValue = $(this).closest(".product-form").find(`.single-option-selector[data-index="option3"]`).val();
        // }
        // if ($(this).attr("data-index") == 'option3') {
        //   var selectedDropDownVal = $(this).closest(".product-form").find(`.single-option-selector[data-index="option2"]`).val();
        //   var thirdValue = $(this).val(); 
        // } 
        // var variantTitle = `${firstValue} / ${selectedDropDownVal} / ${thirdValue}`;
        // var tergetImg = $(`#ProductSelect-default-product-template option[data-value="${variantTitle}"]`).attr("data-variant-image");
        // var tergetVarId = $(`#ProductSelect-default-product-template option[data-value="${variantTitle}"]`).attr("value");
        // var currentImage = $(`.product-image[data-image-id="${tergetImg}"]`).closest(".slick-slide").attr("data-slick-index");
        // $('.product-main-images').slick('slickGoTo',currentImage);
        // $(`#ProductSelect-default-product-template`).val(tergetVarId).change();
        // custom_theme.changePDPData();
      } else {
        var selectedColor = $(this).closest(".product-form").find(".color-value:checked").val();
        var selectedDropDownVal = $(this).val();
        var variantTitle = `${selectedColor} / ${selectedDropDownVal}`;
        var tergetImg = $(`#ProductSelect-default-product-template option[data-value="${variantTitle}"]`).attr("data-variant-image");
        var tergetVarId = $(`#ProductSelect-default-product-template option[data-value="${variantTitle}"]`).attr("value");
        var currentImage = $(`.product-image[data-image-id="${tergetImg}"]`).closest(".slick-slide").attr("data-slick-index");
        $('.product-main-images').slick('slickGoTo',currentImage);
        $(`#ProductSelect-default-product-template`).val(tergetVarId).change();
        custom_theme.changePDPData();
      }
    });
    $(document).on("change",".color-swatch-wrap .color-value", function(){
      var selectedColor = $(this).val();
      var selectedDropDownVal = $(this).closest(".product-form").find(".single-option-selector.active").val();
      var variantTitle = `${selectedColor} / ${selectedDropDownVal}`;
      var tergetImg = $(`#ProductSelect-default-product-template option[data-value="${variantTitle}"]`).attr("data-variant-image");
      var tergetVarId = $(`#ProductSelect-default-product-template option[data-value="${variantTitle}"]`).attr("value");
      var currentImage = $(`.product-image[data-image-id="${tergetImg}"]`).closest(".slick-slide").attr("data-slick-index");
      $('.product-main-images').slick('slickGoTo',currentImage);
      $(`#ProductSelect-default-product-template`).val(tergetVarId).change();
      custom_theme.changePDPData();
    });
  } else {
    $(document).on("change",".single-option-selector", function(){
      var tergetImg = $("#ProductSelect-default-product-template option:selected").attr("data-variant-image");
      var currentImage = $(`.product-image[data-image-id="${tergetImg}"]`).closest(".slick-slide").attr("data-slick-index");
      $('.product-main-images').slick('slickGoTo',currentImage);
      custom_theme.changePDPData();
    });
  }

  $(document).on("click",".custom-variants-box  li", function(){
    var tergetImg = $(this).attr("data-variant-image");
    var currentImage = $(`.product-image[data-image-id="${tergetImg}"]`).closest(".slick-slide").attr("data-slick-index");
    $('.product-main-images').slick('slickGoTo',currentImage);
  });
  
  if($(".template-aloe-vera-mattress-protector").length > 0 || $(".template-oyashe-bed").length > 0 || $(".template-oyesha-box-bed").length > 0){
    $('select.select--height').on('change', function () {
      console.log('jijijijijiji22222222')
      var valueSelected = this.value;
      $(".single-option-selector").removeClass("active");
      $(`.single-option-selector[data-type="${valueSelected}"]`).addClass("active");
    });
    if($('.template-oyesha-box-bed .color-select-dropdown').length > 0){      
      console.log('112121212');
      $(document).on("change",".template-oyesha-box-bed .color-select-dropdown .color-value", function(){
        console.log('kojoik');
        var valueSelected = this.value;
        $(this).closest('.color-select-dropdown').find('.single-option-selector').val(valueSelected).trigger('change');        
      });
      $('.template-oyashe-bed select.single-option-selector').on('change', function() {
        var valueSelected = this.value;
        var currentSelect =$('select#ProductSelect-default-product-template').find(`option[data-value="${valueSelected}"]`).val()
        $('select#ProductSelect-default-product-template').val(currentSelect).trigger('change');
      });
    }else{
     $('.template-aloe-vera-mattress-protector select.single-option-selector, .template-oyashe-bed select.single-option-selector').on('change', function() {
      var valueSelected = this.value;
      var currentSelect =$('select#ProductSelect-default-product-template').find(`option[data-value="${valueSelected}"]`).val()
      $('select#ProductSelect-default-product-template').val(currentSelect).trigger('change');
    }); 
    }    
  }  
  // PDP Page mobile image slider changes on arrow click
  // $(document).on('click', '.product-slideshow-navigation', function(){
  //   custom_theme.pdpImageSliderUsingNavArrow($(this));
  // });
  // Mobile menu accorion 
  $(document).on("click", ".mobile-menu-parent-li.site-nav--has-dropdown .site-nav__link", function() {
    if ($(this).closest(".site-nav--has-dropdown").hasClass("active")) {
      $(this).closest(".site-nav--has-dropdown").removeClass("active");
    } else {
      $(".mobile-menu-parent-li.site-nav--has-dropdown").removeClass("active");
      $(this).closest(".site-nav--has-dropdown").addClass("active");
    }
  });
  //  Header search bar click event 
  var searchBtn = $(".site-header-wrap .search-icon, .site-header-wrap .search-icon-mobile");
  searchBtn.click(function(){
    $(".header-search-form-wrapper").toggleClass("active");
    $(".bg-transparent").toggle();
    if ($(".header-search-form-wrapper").hasClass('active')) {
      $("body").css("overflow","hidden");
    } else {
      $("body").css("overflow","visible");
    }
    $(".header-search-form-wrapper .header-search-from-input").focus();
  });
  // mobile menu open 
  var mobileNavbarIcon = $(".mobile-bar-icon .navbar-icon");
  mobileNavbarIcon.click(function(){
    $(".mobile-menu-parent-li").removeClass("active");
    $(".header-search-form-wrapper").removeClass("active");
    $("#mobile-sidebar-drawer").addClass("open");
    $(".bg-transparent").addClass('active');
    $("body").css("overflow","hidden");
  });
  // mobile menu close
  var mobileNavbarClose = $(".mobile-sidewrap-header .close-icon");
  mobileNavbarClose.click(function(){
    $("#mobile-sidebar-drawer").removeClass("open");
    $(".bg-transparent").removeClass('active');
    $("body").css("overflow","visible");
  });
  //  faq's toogle events 
  $(".faq-wrapper .faq-wrapper-inner .accordion-title").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".accordion-body").slideUp(200);
    } else {
      $(".faq-wrapper .faq-wrapper-inner .accordion-title").removeClass("active");
      $(this).addClass("active");
      $(".accordion-body").slideUp(200);
      $(this).siblings(".accordion-body").slideDown(200);
    }
  });
  $(document).on('click','.upsell-wrapper .upsell-product--cta button', function(){
    var vid = $(this).closest('.upsell-wrapper').data('vid');
    if(vid){
      var $button = $(this);
      $(this).text('Adding...');
      custom_theme.addToCartViaId({vid:vid, qty:1, prop: null}, 
        function(res){
        $button.text('+ Add to cart');
        alert('Product has been added successfully!');
      }, function(err){
        $button.text('+ Add to cart');
        alert('Fail');
      });
    }
  });
  $(document).on('click','.product-card-wrapper .upsell-product-cta', function(){
    var vid = $(this).data('var-id');
    if(vid){
      var $button = $(this);
      $(this).text('Adding...');
      custom_theme.addToCartViaId(
        {vid:vid, qty:1, prop: null}, 
        function(res){
          $button.text('Added To cart');
          setTimeout(function() {
            $button.text("Add To cart");
          },5000);
        }, function(err){
          $button.text('Add to cart');
          alert('Fail');
        }
      );
    }
  });
  $(document).on('click','.qtybox .qty-btn', function(){
    var $qtybox = $(this).closest('.qtybox').find('input[name="quantity"]');
    var qty = $qtybox.val();
    qty = parseInt(qty);
    if($(this).hasClass('minus') && qty > 1){
      qty -= 1;
    } 
    if($(this).hasClass('plus')){
      qty += 1;
    }
    $qtybox.val(qty)
  });
  $(document).on('click','.combine-product-tabs .combine-product-tabs--left li', function(){
    $(".selector-main-wrapper").show();
    $(".available-size").removeClass("custom-size-wrapper");
    $('.form-info').hide();
    var size = $(this).data('tab');
    var unit = $('.swatch-size-wrapper .select--height').val();
    var elemAttribute = size + '-' + unit;
    $(this).addClass('active').siblings('li').removeClass('active');
    $(this).closest('form').find('.shopify-payment-button').show();
    var $targetSelect = $('.swatch-size-wrapper select[data-type]').removeClass('active').siblings('select[data-type="'+elemAttribute+'"]');
    $targetSelect.addClass('active');
    $targetSelect.val($targetSelect.val()).trigger('change');
    $('.combine-product-tabs .combine-product-tabs--right').removeClass('active');
    $('.swatch-size-wrapper .custom-size').removeClass('active').find('.mtm-input').val('');
  });
  $(document).on('click','.swatch-size-wrapper .custom-size #submitMtm', function(){
    $('.form-info').hide();
    var $parent = $(this).closest('.swatch-size-wrapper');
    var length = $parent.find('input[name="properties[Length]"]').val();
    var breadth = $parent.find('input[name="properties[Breadth]"]').val();
    console.log(length);
    console.log(breadth);
    if(length == '' || breadth == ''){
      $('.form-info').removeClass('success').addClass('error').html('All fields are mandatory').fadeIn();
    } else if (parseInt(length) < 15 || parseInt(breadth) < 15 || parseInt(length) > 84 || parseInt(breadth) > 84){
      alert('Please ensure that you have added your dimensions in inches and not in feet/cms”');
      $('.form-info').removeClass('success').addClass('error').html('Please ensure that you have added your dimensions in inches and not in feet/cms”.').fadeIn();      
    } else if (length.indexOf('.') > -1 || breadth.indexOf('.') > -1){
      alert('Please ensure that you have added your dimensions without any decimals');
      $('.form-info').removeClass('success').addClass('error').html('Please ensure that you have added your dimensions without any decimals.').fadeIn();      
    } else {
      length = parseFloat(length);
      breadth = parseFloat(breadth);
      height = null;
      $('.swatch-size-wrapper .swatch-opt').each(function(index, elem){
        if(index > 0){
          height = parseInt($(this).find('select.active').val());
        }
      });
      // var minLen = 72;
      // var minWidth = 36;
      // var maxSize = 84;
      // var errMsg_min = 'Sorry, Minimum available length x width is : 48 inch x 24 inch.';
      // var errMsg_max = 'Sorry! We do not make mattresses longer than 84 inches.';
      // if(length > maxSize || breadth > maxSize){
      //   $('.form-info').removeClass('success').addClass('error').html(errMsg_max).fadeIn();
      //   return false;
      // }
      try{
        if(custom_theme.current_v && custom_theme.product.productVariants){
          var size_index = custom_theme.current_v.sizeIndex;
          var size_arr = custom_theme.product.productVariants;
          var filteredSizeArr = size_arr.filter(function(v){
            if(v.available){
              var sizeOpt = v[size_index].toLowerCase();
              var sizeOptArr = sizeOpt
              .replace(/inch/g,'')
              .trim()
              .split('x');
              var v_len = parseFloat(sizeOptArr[0].trim());
              var v_width = parseFloat(sizeOptArr[1].trim());
              var v_height = parseFloat(sizeOptArr[2].trim());              
              return v_len == length && v_width == breadth && height == v_height ;
            } else {
              return 0;
            }
          });
          if(filteredSizeArr.length == 0){
            filteredSizeArr = size_arr.filter(function(v){
              if(v.available){
                var sizeOpt = v[size_index].toLowerCase();
                var sizeOptArr = sizeOpt
                .replace(/inch/g,'')
                .trim()
                .split('x');
                var v_len = parseFloat(sizeOptArr[0].trim());
                var v_width = parseFloat(sizeOptArr[1].trim());
                var v_height = parseFloat(sizeOptArr[2].trim());
                if (height == '6' || height == '8' || height== '10' || height== '7' || height== '9' ) {
                  return v_len >= length && v_width >= breadth && v_height >= height  ;              
                } else {
                  return v_len >= length && v_width >= breadth && height >= v_height ;
                }
              } else {
                return 0;
              }
            });
          }
          if(filteredSizeArr.length){
            filteredSizeArr = filteredSizeArr;
            var v_id = filteredSizeArr[0].id;
            var found_v = $('form[action="/cart/add"] select[name="id"] option[value="'+v_id+'"]').attr('value');
            var foundMatch = false;
            if(!found_v){
              filteredSizeArr.map(function(v){
                if(foundMatch){
                  return false;
                }
                found_v = $('form[action="/cart/add"] select[name="id"] option[value="'+(v.id)+'"]').attr('value');
                if(found_v){
                  foundMatch = true;
                }
              });
            }
            if(found_v){
              $('.form-info').removeClass('error').addClass('success').html('Variant Found!').fadeIn();
              setTimeout(function(){
                $('.form-info').hide();
              },3000);
              $('select.custom-variants-dropdown').val(found_v).trigger('change');
              custom_theme.changePDPData();
              var selectedVarId = $(".custom-variants-dropdown").val(),
                  selectedVarQty = $("#Quantity").val(),
                  data = {
                    id: selectedVarId,
                    quantity: selectedVarQty,
                    properties: {
                      'Length Size': $("#lengthInput").val(),
                      'Breadth Size': $("#breadthInput").val(),
                      'Height Size' :$(".single-option-selector-height").val()
                    }
                  };
              $.ajax({
                url: "/cart/add.js",
                type: "post",
                dataType :'JSON',
                data: data,
                success: function(){
                  custom_theme.miniCartInit();
                }
              })
            }
          } else {
            $('.form-info').removeClass('success').addClass('error').html('Sorry!, No variant found.').fadeIn();
          }
        }
      } catch(err){
        console.error('Error', err);
      }
    }
  });
  $(document).on('click','.combine-product-tabs .combine-product-tabs--right', function(){
    $('.form-info').hide();
    var size = $(this).data('tab');
    $('.combine-product-tabs .combine-product-tabs--left li').removeClass('active');
    $(this).addClass('active');
    $('.swatch-size-wrapper .custom-size').addClass('active');
    $(".available-size.option-wrapper").addClass("custom-size-wrapper");
    $(".selector-main-wrapper").hide(); 
  });
  $(document).on('change','.swatch-size-wrapper select.select--height', function(){    
    var size = $('.combine-product-tabs .combine-product-tabs--left li.active').data('tab');
    var unit = $(this).val();
    var elemAttribute = size + '-' + unit;
    var $targetSelect = $('.swatch-size-wrapper select[data-type]').removeClass('active').siblings('select[data-type="'+elemAttribute+'"]');
    $targetSelect.addClass('active');
    if($('[name="properties[Height]"]').length > 0){
     $('[name="properties[Height]"]').each(function(i, e){
      $(this).find('option').each(function(i, e){
        var txtval = $(e).val().toLowerCase().replaceAll(" ", "").replaceAll('inch','').trim();
        if(unit == 'ft'){
          var mainval1 = parseInt(txtval) / 12;
          var feetvalue = `${mainval1.toFixed(2)} ft`;
        }else if(unit == 'cm'){
          var mainval1 = 2.54 * parseInt(txtval);
          var feetvalue = `${mainval1.toFixed(2)} cm`;
        }else{
          var mainval1 = parseInt(txtval);
          var feetvalue = `${mainval1} inch`;
        }
        $(e).text(feetvalue);
      });
     }); 
    }    
    if(unit === 'ft' || unit === 'cm'){
      var similarVal = $targetSelect.find('option:selected').attr('data-value'); 
      if(similarVal){
        $(this).closest('form').find('input.size--hidden').val(similarVal);
      }
    }
  });
  $(document).on('change','.swatch-size-wrapper .swatch-opt select', function(){
    var selected_opts = '';
    var selected_cat = $('.combine-product-tabs .combine-product-tabs--left li.active').attr('data-tab');
    if(selected_cat){
        selected_cat = selected_cat.toLowerCase();
    }
    $('.swatch-size-wrapper .swatch-opt').each(function(index, elem){
        var selectVal = $(this).find('select.active').val();
        if(index > 0){
          selected_opts += ' x ' + selectVal + ' (' + selected_cat + ')' ;
        } else {
          selected_opts += selectVal
        }
    });
    
    selected_opts = custom_theme.handleize(selected_opts);
    console.log(selected_opts);
    var $found_opt = $('select.custom-variants-dropdown option[data-title="'+selected_opts+'"]');
    var found_v = $found_opt.attr('value');
    var price = $found_opt.attr('data-price');
    var c_price = $found_opt.attr('data-cprice');
    if(found_v){
      try{
        $('.form-info').hide();
        if($(this).hasClass('single-option-selector-ft') || $(this).hasClass('single-option-selector-cm')){
          var similarVal = $(this).find('option:selected').attr('data-value');
          if(similarVal){
            $(this).closest('form').find('input.size--hidden').val(similarVal);
          }
        }
        $('select.custom-variants-dropdown').val(found_v).trigger('change');
        custom_theme.changePDPData();
      } catch(err){
        console.error('Error',err);
      }
    } else {
      if($(".combine-product-tabs--right.active").length > 0){
        $('.form-info').hide();
      } else {
        $('.form-info').removeClass('success').addClass('error').html('Sorry! No variant found, Please select other one.').fadeIn();
      }
    }
  });
  $('.heres-how-our-journey-wrapper .read-more-btn').click(function(){
    $(this).addClass("active");
    $(".read-less-btn").addClass("active");
    $(this).closest(".items-wrapper").find(".message-list").slideDown('slow');
  });
  $('.heres-how-our-journey-wrapper .read-less-btn').click(function(){
    $(this).removeClass("active");
    $(".read-more-btn").removeClass("active");
    $(".message-list").slideUp('slow');
  });
  $(".custom-variants-box li").click(function(){
    if ($(".template-baby-mattress").length>0) {
      $(this).addClass('active').siblings('li').removeClass('active');
      var target = $(this).attr("data-tab-value");
      var sizeVal = $(this).closest(".product-form").find(`.single-option-selector[data-index="option2"]`).val();
      var heightVal = $(this).closest(".product-form").find(`.single-option-selector[data-index="option3"]`).val();
      var variantTitle = `${target} / ${sizeVal} / ${heightVal}`;
      var tergetImg = $(`#ProductSelect-default-product-template option[data-value="${variantTitle}"]`).attr("data-variant-image");
      var tergetVarId = $(`#ProductSelect-default-product-template option[data-value="${variantTitle}"]`).attr("value");
      var currentImage = $(`.product-image[data-image-id="${tergetImg}"]`).closest(".slick-slide").attr("data-slick-index");
      $('.product-main-images').slick('slickGoTo',currentImage);
      $(`#ProductSelect-default-product-template`).val(tergetVarId).change();
      custom_theme.changePDPData();  
    } else {
      $(this).addClass('active').siblings('li').removeClass('active');
      var custom_variant_target = $(this).data('value');
      $("#ProductSelect-product-template-default").val(custom_variant_target).trigger("change");
      var target = $(this).data("tab-title");
      $(".production-desc").find('li').removeClass("active");
      $(".production-desc").find(`li[data-handle='${target}']`).addClass("active");
    }
  });
  $('.accordian_btn.Collapsible__Button').click(function() {
    $(this).toggleClass("open");
    if($(this).hasClass('open')){
      $(this).next(".Collapsible__Inner").css({
        "overflow": "visible",
        "height": "auto"
      });
    } else {
      $(this).next(".Collapsible__Inner").css({
        "overflow": "hidden",
        "height": "0"
      });
    }
  });
};
// $(document).on("click", ".product-main-image .next-image", function(){
//   var tergetImg = $(".product-slideshow-pagination-item.active").attr("data-high-res");
//   $(".product-main-image img").attr('src',tergetImg);
// });
$(document).on("click",".product-thumbnails .product-image, .product-thumbnails .slick-prev,.product-thumbnails .slick-next",function(){
  $(".product-main-image").addClass("hide");  
  $(".product-main-images").show();
  $(".product-main-images").slick('refresh');
})
custom_theme.changePDPData = function () {
  var $mainSelectOpt = $('.custom-variants-dropdown option:selected'); 
  let variantPrice = $mainSelectOpt.attr('data-variant-price');
  let variantId = $mainSelectOpt.val(); 
  let price_mrp = $mainSelectOpt.attr('data-variant-price')/100;
  let price_mrp_compare = $mainSelectOpt.attr('data-variant-mrp-price')/100;
  let disc_value = theme.product.disc_value;
  console.log('jsijsijdijdijdijidijidjijdj');
  if($('.product-main-image').length > 0){
    $(".product-main-images").hide(); 
     $(".product-main-image").removeClass("hide");  
  }  
  console.log($mainSelectOpt.attr("data-var-img"));
  $(".product-main-image img").attr('src',$mainSelectOpt.attr("data-var-img"));
  $('.product-var-price .money').html(theme.Currency.formatMoney(variantPrice, window.Theme.moneyFormat).replace(/.0*$/,''));
  $('.variant_value_metafield').hide();
  console.log($mainSelectOpt);
  $('.variant_value_metafield.variant_'+variantId).show();  
  if(price_mrp) {
    var calc_disc_amt = (price_mrp * disc_value)/100;   
    var myint = 100;
    var myfloat = myint*1.0;
    var special_price = parseInt(price_mrp - calc_disc_amt)*myfloat;
    console.log(special_price);
    // var price_mrp_formatted = theme.Currency.formatMoney((price_mrp_compare*100), window.Theme.moneyFormat).replace(/.0*$/,'');
    var price_mrp_formatted = theme.Currency.formatMoney(variantPrice, window.Theme.moneyFormat).replace(/.0*$/,'');
    $('.product-price .price--mrp').show().find('.money').html(price_mrp_formatted);
    var calc_disc_amt_formatted = theme.Currency.formatMoney((price_mrp - special_price)*100, window.Theme.moneyFormat);
    console.log(price_mrp);
    console.log(special_price);
    $('.product-price .you-save').show().find('.money').html(theme.Currency.formatMoney((price_mrp*100 - special_price), window.Theme.moneyFormat).replace(/.0*$/,'')).fadeIn();
    var special_price_formatted = theme.Currency.formatMoney(special_price, window.Theme.moneyFormat).replace(/.0*$/,'');
    $('.product-price .special--price').show().find('.money').html(special_price_formatted);
    var new_sale_percentage_price = (100 - (special_price / price_mrp)).toFixed(0);
    if($('.save-disc-val').html().includes("%")){
      var new_sale_percentage_price_per = new_sale_percentage_price
    }else{
      var new_sale_percentage_price_per = new_sale_percentage_price+'%'
    }
    $('.product-price .you-save .you_save_in_percentage').html(new_sale_percentage_price_per);
    console.log('00000000',new_sale_percentage_price.includes("%"));
  } else {
    $('.product-price .price--mrp, .product-price .special--price, .product-price .you-save').hide();
  }
  var selectedPPN = $mainSelectOpt.attr("data-sku");
  $(".variant-sku").find(".other-info-sku").removeClass("active");
  $(".variant-sku").find(".other-info-sku").hide();
  $(".variant-sku").find(`.other-info-sku[data-variant-id="${selectedPPN}"]`).addClass("active");

  $(".cms-wrap").find(".other-info-cms").removeClass("active");
  $(".cms-wrap").find(".other-info-cms").hide();
  $(".cms-wrap").find(`.other-info-cms[data-variant-id="${selectedPPN}"]`).addClass("active");
  
  $(".price-per-night").find(".other-info-ppn").removeClass("active");
  $(".price-per-night").find(".other-info-ppn").hide();
  $(".price-per-night").find(`.other-info-ppn[data-variant-id="${variantId}"]`).addClass("active");

   console.log($mainSelectOpt);
  console.log("$mainSelectOpt.attr('disabled')");
  if($mainSelectOpt.attr('disabled') == 'disabled'){
    $('.product-form__cart-submit').attr('disabled','disabled').find('span').text('Sold out');
    $('.shopify-payment-button').hide();
  }else{
    if($('.product-form__cart-submit').hasClass('has_preroder')){
     $('.product-form__cart-submit').removeAttr('disabled').find('span').text('Pre order'); 
    }else{
     $('.product-form__cart-submit').removeAttr('disabled').find('span').text('Add to cart');
    }       
  }
}
custom_theme.handleize = function (str) {
  return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};
//  videoFrame script added
custom_theme.videoFrame = function(){
  var iframe = $(".vimeo-video-wrapper");
  if(iframe.length){
    var player = new Vimeo.Player(iframe);
    var autoplay = iframe.attr('data-autoplay');
    if(autoplay == 1){
      player.play();
    }
    $(".video-section .play-btn").click(function(event) {
      event.stopPropagation();
      $(".video-wrap-inner").show();
      $(".banner-image-wrapper").hide();
      var parent = $(this).closest('.img-wrapper');
      var play_btn = $(this);
      if(!play_btn.hasClass('loaded')){
        play_btn.addClass('loaded');
        setTimeout(function(){
          play_btn.hide().removeClass('active');
          $(".pause-btn",parent).show().addClass('active');
        },1500);
      }
      else{
        play_btn.hide().removeClass('active');    
        $(".pause-btn",parent).show().addClass('active');
      }
      player.on("load",function(){
        console.log("loaded");
      })
      player.play();
    });
    $(".video-section .pause-btn").click(function(event) {
      event.stopPropagation();
      $(this).hide().removeClass('active');
      var parent = $(this).closest('.img-wrapper');
      $(".play-btn",parent).show().addClass('active');;
      player.pause();
    });
    $(".video-section .btn-wrappe").click(function(event) {
      if(screen.width < 1024){
        var parent = $(this).closest('.img-wrapper');
        $(".player-btn.active",parent).click();
      }
    });
  }
};
custom_theme.pdpMainImageSlider = function(){
  $('.product-main-images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    asNavFor: '.product-thumbnails',
    infinite : false,
    adaptiveHeight: true
  });
  $('.product-thumbnails').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product-main-images',
    dots: false,
    infinite : false,
    focusOnSelect: true
  });
}
custom_theme.featured_collection_slider = function (){
    var target = $(".hp-featured-collection .products-item-wrap");
    if(custom_theme.is_mobile){
      target.slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        centerPadding: '30px'
      });
    } else {
      target.slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1
      });
    }
};
custom_theme.collectionPage = function(){
  console.log($(".lb-images .lb-slides").length);
  if($(".lb-images .lb-slides").length && !$(".lb-images .lb-slides").hasClass('slick-initialized')){
    $(".lb-images .lb-slides").slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }
}
custom_theme.getCart = function(successCallback){
  fetch('/cart.js')
  .then(function(res){
    return res.json();
  }).then(function(cart){
    if(successCallback && typeof successCallback === 'function'){
      successCallback(cart);
    }
  })
  .catch(function(err){
    console.log('Err',err)
  });
}
custom_theme.addToCartViaId = function(data, successCallback, errCallBack){
  if(data && data.vid){
    if(!data.qty){
      data.qty = 1;
    }
    let formData = {
      'items': [
        {
          'id': data.vid,
          'quantity': data.qty
        }
      ]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(function(res){
      return res.json();
    }).then(function(data){
      custom_theme.getCart(function(cart){
        var cartCountHtml = '<span class="count">'+cart.item_count+'</span>';
        if($('.header .cart-icon .count').length){
          $('.header .cart-icon .count').text(cart.item_count);
        } else {
          $('.header .cart-icon a').append(cartCountHtml);
        }
      });
      if(successCallback && typeof successCallback === 'function'){
        successCallback(data);
      }
    }).catch(function(error){
      console.error('Error:', error);
      if(errCallBack && typeof errCallBack === 'function'){
        errCallBack(error);
      }
    });
  }
};
custom_theme.testimonials_slider = function (){
  var target = $(".textimonials-wrapper .quotes-slider");
  if(custom_theme.is_mobile){
    target.slick({
      dots: true,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  } else {
    target.slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1
    });
  }
}
custom_theme.enterprenur__slider = function (){
  var target = $(".enterpreneur-wrapper .right-content");
  target.slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
  });
};
custom_theme.initPDPSlider = function(){
  $('.product-single__photos-mob').on('init', function(event, slick){
    $('.product-single__photos-mob').addClass('loaded');
  });
  $('.product-single__photos-mob').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    arrows: true,
    fade: true,
    asNavFor: '.product-thumb-img'
  });
  $('.product-thumb-img').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.product-single__photos-mob',
    focusOnSelect: true,
    arrows : false,
    infinite:false
  });
};
custom_theme.filterVariant = function(){
  if(custom_theme.current_v && custom_theme.current_v.title && custom_theme.current_v.position){
    custom_theme.current_v['variants'] = custom_theme.product.variants.filter(function(v){
      var v_opt = v[custom_theme.current_v.position].toLowerCase();
      return v_opt == custom_theme.current_v.title;
    });
  }
};
custom_theme.why_flo_review_wrapper = function (){
  var target = $(".why-flo-verified-photo-reviews-wrapper .review-wrapper");
  if(custom_theme.is_mobile){
    target.slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  } else {
    target.slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
}
custom_theme.why_flow_affordable_wrapper_product_slider = function (){
  var target = $(".why-flow-affordable-wrapper .products-item-wrap");
  if(custom_theme.is_mobile){
    target.slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      variableWidth: true,
      centerPadding: '20%'
    });
  } else {
    target.slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
}
custom_theme.hp_product_item_block = function (){
  $(".hp-product-block-wrapper .product-block").slick({
    dots: true,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll:1
  });
};
custom_theme.productPageSlider = function(){
  if($(".template-product-landing").length > 0){
    $(".default-image-slider").slick();
  }
}

// custom_theme.upsellProductAddToCart
custom_theme.upsellProductAddToCart = function(){
  $(document).on("click",".upsell-cta-button", function(e){
    e.preventDefault();
    var button = $(this);
    button.text("Adding...");
    var variantId = $(this).closest(".cross-upsell-wrapper").find(".var-id").val();
    var qty = $(this).closest(".cross-upsell-wrapper").find(".product-form__input").val();
    $.ajax({
      url: "/cart/add.js",
      type: "post",
      dataType :'JSON',
      data: {
        quantity: qty,
        id: variantId
      },
      success: function(){
        custom_theme.miniCartInit();
        button.text("Add to cart");
      },
      error: function(){
        button.text("Add to cart");
      }
    })
  })
}

// upselle product wrap
$('.cross-upsell-outer-wrapper').slick({
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  adaptiveHeight: true,
  arrows : true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

custom_theme.upsell_product_variant_selected = function(){
  $(document).on('change', 'select.swatch-drop-down', function () {
    if ($(this).closest(".cross-upsell-wrapper").find(".swatch-color").length > 0) {
      var colorVal = $(this).closest(".cross-upsell-wrapper").find(`input[type="radio"]:checked`).val();
      var sizeVal = $("option:selected", this).attr("data-value");
      var optionSelected = colorVal + '-' + sizeVal;
    } else {
      var optionSelected = $("option:selected", this).attr("data-value");
    }
    var selectedVar = $(this).closest(".cross-upsell-wrapper").find(`[name="id"]`).find(`option[data-variant-title="${optionSelected}"]`).val();
    var varMrpPrice = $(this).closest(".cross-upsell-wrapper").find(`[name="id"]`).find(`option[data-variant-title="${optionSelected}"]`).attr("data-mrp-price").replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    var varRegularPrice = $(this).closest(".cross-upsell-wrapper").find(`[name="id"]`).find(`option[data-variant-title="${optionSelected}"]`).attr("data-compare-price").replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    $(this).closest(".cross-upsell-wrapper").find(".products-item__price .compaer-at-price").text('Rs. '+varRegularPrice);
    $(this).closest(".cross-upsell-wrapper").find(".products-item__price .price").text('Rs. '+varMrpPrice);
    $(this).closest(".cross-upsell-wrapper").find(".var-id").val(selectedVar);
  });
  $(document).on('change','input:radio:checked',function () {
    if ($(this).closest(".cross-upsell-wrapper").find(".swatch-drop-down").length > 0) {
      var colorVal = $(this).val();
      var sizeVal = $(this).closest(".cross-upsell-wrapper").find(`.swatch-drop-down option:selected`).attr("data-value");
      var optionSelected = colorVal + '-' + sizeVal;
    } else {
      var optionSelected = $(this).val();
    }
    var selectedVar = $(this).closest(".cross-upsell-wrapper").find(`[name="id"]`).find(`option[data-variant-title="${optionSelected}"]`).val();
    var varMrpPrice = $(this).closest(".cross-upsell-wrapper").find(`[name="id"]`).find(`option[data-variant-title="${optionSelected}"]`).attr("data-mrp-price").replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    var varRegularPrice = $(this).closest(".cross-upsell-wrapper").find(`[name="id"]`).find(`option[data-variant-title="${optionSelected}"]`).attr("data-compare-price").replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    $(this).closest(".cross-upsell-wrapper").find(".products-item__price .compaer-at-price").text('Rs. '+varRegularPrice);
    $(this).closest(".cross-upsell-wrapper").find(".products-item__price .price").text('Rs. '+varMrpPrice);
    $(this).closest(".cross-upsell-wrapper").find(".var-id").val(selectedVar);
  });
}
custom_theme.DiscountedCode = function(){

}
custom_theme.cartPageDiscounteApply = function(){
  $(document).on('change','#discount_code', function (e) {
    var valueSelected = this.value;
    $(".side-cart-drawer .cart").css('height',`auto`);    
    if (valueSelected=='none') {
      $(".discount-code").val('');
      $("#discount_code_btn").attr("disabled",true).addClass("disabled");
      $(".success-msg, .discount-price-wrapper").hide();
      var cartTotal = $(".side-cart-checkout-btn").attr("data-cart-total-price");
      var totalPrice = theme.Currency.formatMoney(cartTotal, window.Theme.moneyFormat);
      $('.cart__footer .side-cart-checkout-btn').val(`BUY NOW - ${totalPrice}`);            
    } else {
      $(".discount-code-apply-wrapper").addClass("value-selected-using-dropdown");
      $(".discount-code").val(valueSelected);
      $("#discount_code_btn").attr("disabled",false).removeClass("disabled").trigger('click');
      $(".success-msg, .discount-price-wrapper").hide();            
    }
  });
  $(document).on("keyup change", ".discount-code", function() {
    $(".side-cart-drawer .cart").css('height',`auto`);
    var cartTotal = $(".side-cart-checkout-btn").attr("data-cart-total-price");
    var totalPrice = theme.Currency.formatMoney(cartTotal, window.Theme.moneyFormat);
    $('.cart__footer .side-cart-checkout-btn').val(`BUY NOW - ${totalPrice}`);
    $(".success-msg,.discount-price-wrapper").hide();
    $(".discount-code-apply-wrapper").removeClass("value-selected-using-dropdown");
    $("#discount_code").val('none');
    // var footerHeight = $('.cart__footer').height();
    // $(".side-cart-drawer .cart").css('height',`calc(100% - ${footerHeight}px)`);
    if($(this).val().length>0){
      $("#discount_code_btn").removeClass("disabled").removeAttr("disabled");
    } else {
      $("#discount_code_btn").addClass("disabled").attr("disabled","disabled");
    }
  });
  $(document).on('click', '#discount_code_btn', function(event){
    event.preventDefault();
    var __this = $(this);
    var data_text = $(this).attr("data-text");
    var theDiscount = $('.discount-code').val();
    if(theDiscount== '') {
    } else {
      $(this).text(data_text);
      var success_msg = $('#discount_code_btn').attr("data-success-msg");
      var toRedirect = 'https://www.flomattress.com/discount/' + theDiscount + '?redirect=/cart';
      if ($(".discount-code-apply-wrapper").hasClass("value-selected-using-dropdown")) {
        custom_theme.discountPercantage = $("#discount_code option:selected").attr("data-percentage-val");
        custom_theme.successMsg = (`Discounted code applied!`);
      } else {
        custom_theme.successMsg = (`<span style="font-weight: 400;">Your discounted code *${theDiscount}* has been applied. <br /> <b style="font-weight: 800;"> Please proceed to BUY NOW to see final price.</b><span>`);
      }
      $.ajax({
        url: toRedirect,
      }).done(function() {
        if ($(".discount-code-apply-wrapper").hasClass("value-selected-using-dropdown")) {
          $(".discount-price-wrapper").show();
          $(".discount-code-apply-wrapper").removeClass("value-selected-using-dropdown");
          var cartTotal = $(".side-cart-checkout-btn").attr("data-cart-total-price");
          var discountPrice = cartTotal*custom_theme.discountPercantage/100;
          var totalPrice = theme.Currency.formatMoney(cartTotal - discountPrice, window.Theme.moneyFormat);
          $('.discount-price-wrapper .total-price').find(".price").text(totalPrice);
          $('.discount-price-wrapper .discount-price').find(".price").text('-'+theme.Currency.formatMoney(discountPrice, window.Theme.moneyFormat));
          $('.discount-price-wrapper .sub-total').find(".price").text(theme.Currency.formatMoney(cartTotal, window.Theme.moneyFormat));
          $('.cart__footer .side-cart-checkout-btn').val(`BUY NOW - ${totalPrice}`);
          $(".success-msg2").html(custom_theme.successMsg).hide();
          $(".success-msg").html(custom_theme.successMsg).show();
          var footerHeight = $('.cart__footer').height();
          $(".side-cart-drawer .cart").css('height',`calc(100% - ${footerHeight}px)`);
          $(".discount-code").val('');
          $("#discount_code_btn").addClass("disabled");
          __this.closest('form').append('<input type="hidden" name="discount" value="'+theDiscount+'">');
        } else { 
          $(".discount-price-wrapper").hide();
          $(".success-msg").html(custom_theme.successMsg).hide();
          $(".success-msg2").html(custom_theme.successMsg).show();
          var footerHeight = $('.cart__footer').height();
          $(".side-cart-drawer .cart").css('height',`calc(100% - ${footerHeight}px)`);
          var cartTotal = theme.Currency.formatMoney($(".side-cart-checkout-btn").attr("data-cart-total-price"), window.Theme.moneyFormat);
          $('.cart__footer .side-cart-checkout-btn').val(`BUY NOW - ${cartTotal}`);
          __this.closest('form').append('<input type="hidden" name="discount" value="'+theDiscount+'">');
        }
        $("#discount_code_btn").text("Apply Coupon");
      });
    }
  });
}
custom_theme.review_slider = function(){
  $("a.customer-review-link").click(function(){
    $('.loox-float-toggler').trigger('click');
  });
  if($(".customer-review-block-wrapper").length && !$(".customer-review-block-wrapper").hasClass('slick-initialized')){
  $('.customer-review-block-wrapper').slick({
    dots: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: false,
          slidesToShow: 3,
          slidesToScroll: 2,
          dots : false,
          autoplaySpeed: 5000,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots : false,
          autoplaySpeed: 5000
        }
      }
    ]
  });
  }
}
$('.review-block-wrapper-plp').slick({
  dots: true,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 2,
        dots : false,
        autoplaySpeed: 5000,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots : false,
        autoplaySpeed: 5000
      }
    }
  ]
});
custom_theme.init = function(){
  custom_theme.is_Ipad_and_up = $(window).width() > 768;
  custom_theme.is_mobile = $(window).width() < 768;
  if($('body.template-name-default').length){
    custom_theme.filterVariant();
  }
  if($('.swatch-size-wrapper select.select--height').length){
    setTimeout(function(){
      $('.swatch-size-wrapper select.select--height').val('inch').trigger('change');
    },500);
  }
  if(custom_theme.is_mobile){
    custom_theme.initPDPSlider(); 
  }
                               
  custom_theme.clickEvent();
  // custom_theme.videoFrame();   
  custom_theme.collectionPage();
  custom_theme.featured_collection_slider();                               
  custom_theme.testimonials_slider();
  custom_theme.enterprenur__slider();
  custom_theme.why_flo_review_wrapper();
  custom_theme.why_flow_affordable_wrapper_product_slider();
  
  custom_theme.review_slider();
  if ($(".cross-upsell-outer-wrapper").length > 0) {
    custom_theme.upsell_product_variant_selected();
    custom_theme.upsellProductAddToCart();
  }
  if(custom_theme.is_mobile) {
    custom_theme.hp_product_item_block();
  }
  custom_theme.productPageSlider();
  custom_theme.cartPageDiscounteApply();
};
custom_theme.load = function(){
  $( window ).load(function() {
    if(window.location.href.includes('?contact%5Btags%5D=newsletter&form_type=customer#contact_form')){
      $(".newsletter-form-error").removeClass("hide");
    }
  })
};
custom_theme.scroll = function(){
  $(window).scroll(function() {
    if ($(window).scrollTop() > 300) {
      $(".mobile-sticky-button").addClass('active');
    } else {
      $(".mobile-sticky-button").removeClass('active');
    }
  });
};
$(document).ready(function(){
  custom_theme.init();
  custom_theme.pdpMainImageSlider();
  custom_theme.load();
  custom_theme.scroll();
  if($(window).width() < 768){
    $(".as-easy-as-wrapper .image-wrapper").slick({
      dots: true,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    })
  }

  $('body').on('click','.cer-a', function(){
    $('.page-container').addClass('modal-open');
    $(this).closest('.cerificate-col').find('.certificate-modal').addClass('open');
  });
  $('body').on('click','.close-cer-modal',function(){    
    $('.page-container').removeClass('modal-open');
    $(this).closest('.certificate-modal').removeClass('open');
  });

  $('.moreinfo_pop').click(function(){
    $('.page-container').addClass('modal-open');
    $('.more-info-popup').addClass('open');
  });
  $('.more-info-close').click(function(){
    $('.page-container').removeClass('modal-open');
    $('.more-info-popup').removeClass('open');
  });

  $('.measuring_size').find('a').click(function(e){
    e.preventDefault();
    $('.measuring_video').addClass('active').show();
  });
  
  $('.close-popup').click(function(){
      $(this).parent('.measuring_video').removeClass('active').hide();
  });

  $('body').on('click','.view-all_certification,.imagezommer',function(e){
    e.preventDefault();
    var id = $(this).attr('href');
    if($(this).hasClass('hasimglink')){
      if($(this).attr('data-imgurl')){
         var pophtml = `<div class="certification-logos_item-media">
              <img src="${$(this).attr('data-imgurl')}" loading="lazy" class="certification-logos_item-img-pop" />
            </div>`; 
        $(id).find('.certification-popover_contents').html(pophtml);
      }      
    }    
    $(id).show();
    $(id).addClass('active');
  });
  $('.certification-popover_close').click(function(){
   $(this).parents('.certification-popover').hide();
   $(this).parents('.certification-popover').removeClass('active');
  });

  // Pause all videos on the page
  function pauseAllVideos() {
    if($(window).width() > 767){
      $('.video_slideshow .desktop_video video').each(function () {
        this.pause();
      });  
    }else{
      $('.video_slideshow .mobile_video video').each(function () {
        this.pause();
      }); 
    }
    
  
    // $('iframe[src*="youtube.com"]').each(function () {
    //   this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    // });
  
    // $('iframe[src*="vimeo.com"]').each(function () {
    //   const player = new Vimeo.Player(this);
    //   player.pause();
    // });
  }
  
  // Play video on the current slide
  function playCurrentSlideVideo(currentSlide) {
    console.log('Playing video on slide: ', currentSlide);
    
    const currentSlideElement = $('.video_slideshow .slideshow_slider_wrapper .slick-slide[data-slick-index="' + currentSlide + '"]');
    if($(window).width() > 767){
     var maincurrent = currentSlideElement.find('.desktop_video')[0];
    }else{
     var maincurrent = currentSlideElement.find('.mobile_video')[0];
    }
    console.log(maincurrent);
    // Play MP4 video
    if($(window).width() > 767){
      console.log('ifffff')
      var mp4Video = $(maincurrent).find('video')[0];
    }else{
      var mp4Video = $(maincurrent).find('video')[0];
    }
    console.log(mp4Video);
    if (mp4Video) {
      mp4Video.muted = true; // Mute video to allow autoplay
      mp4Video.play().catch(error => console.log('Video autoplay failed', error));
      $(mp4Video).off('ended').on('ended', goToNextSlide);
    }
  
    // // Play YouTube video
    // const youtubeIframe = currentSlideElement.find('iframe[src*="youtube.com"]')[0];
    // if (youtubeIframe) {
    //   console.log('Sending play command to YouTube iframe');
    //   youtubeIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    // }
  
    // // Play Vimeo video
    // const vimeoIframe = currentSlideElement.find('iframe[src*="vimeo.com"]')[0];
    // if (vimeoIframe) {
    //   const vimeoPlayer = new Vimeo.Player(vimeoIframe);
    //   vimeoPlayer.play().catch(error => console.log('Vimeo autoplay failed', error));
    //   vimeoPlayer.off('ended').on('ended', goToNextSlide);
    // }
  }
  
  // Move to the next slide when video ends
  function goToNextSlide() {
    console.log('Video ended, moving to next slide...');
    $('.video_slideshow .slideshow_slider_wrapper').slick('slickNext');
  }
  
  // let youtubePlayers = []; // To store multiple player instances
  
  // if ($('iframe[src*="youtube.com"]').length > 0) {
  //   var tag = document.createElement('script');
  //   tag.src = "https://www.youtube.com/iframe_api";
  //   var firstScriptTag = document.getElementsByTagName('script')[0];
  //   firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  // } else {
  //   console.log('No YouTube iframe found, API not loaded');
  // }
  
  // YouTube API Ready
  // window.onYouTubeIframeAPIReady = function () {
  //   console.log('YouTube API ready!');
  
  //   $('.video_slideshow iframe[src*="youtube.com"]').each(function (index) {
  //     const iframe = this;
  //     console.log('Creating YouTube Player for:', iframe);
  //     const player = new YT.Player(iframe, {
  //       events: {
  //         'onStateChange': function (event) {
  //           console.log('YouTube video state changed', event.data);
  //           if (event.data === YT.PlayerState.ENDED) {
  //             console.log('YouTube video ended');
  //             goToNextSlide();
  //           }
  //         },
  //         'onReady': function () {
  //           console.log('YouTube player ready');
  //         }
  //       }
  //     });
  //     youtubePlayers.push(player);
  //   });
  // }
  
  // Event: When slick slider is fully initialized
  $('.video_slideshow .slideshow_slider_wrapper').on('init', function (event, slick) {
    console.log('Slick slider initialized.');
    setTimeout(function() {
      pauseAllVideos();
      playCurrentSlideVideo(0); // Autoplay first slide
    }, 500); // Wait for slider to fully initialize
  });
  
  // Event: Play video on slide change
  $('.video_slideshow .slideshow_slider_wrapper').on('afterChange', function (event, slick, currentSlide) {
    console.log('Slide changed to: ', currentSlide);
    pauseAllVideos();
    
    // Delay the autoplay to ensure the slide has fully loaded
    setTimeout(function() {
      playCurrentSlideVideo(currentSlide);
    }, 500); // 500ms delay ensures the slide is fully loaded
  });
  
  // Event: On slider's "afterChange", check if we are on the first slide after the loop and autoplay it again
  $('.video_slideshow .slideshow_slider_wrapper').on('afterChange', function (event, slick, currentSlide) {
    if (currentSlide === 0) {
      console.log('Slider looped back to the first slide, autoplaying video again...');
      setTimeout(function () {
        playCurrentSlideVideo(0); // Play the first slide again when the slider loops
      }, 500); // Slight delay to make sure the first slide is loaded
    }
  });

  $('body').on('click','.toggle-button', function(){
    $(this).next().slideToggle();
    $(this).toggleClass('active');
  });

// Initialize the Slick slider
$('.video_slideshow .slideshow_slider_wrapper').slick({
  infinite: true,
  autoplay: false, 
  arrows: false,
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1
});
  
});